import React from 'react';

const OtherPage = () => {
  return (
    <div>
      <h1>This is the other page</h1>
    </div>
  );
};

export default OtherPage;
